import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'periodDurationPipe'
})
export class PeriodDurationPipe implements PipeTransform {

  transform(value: string): string {
    // Regular expression to parse ISO 8601 duration
    const regex = /P(?:\d+Y)?(?:\d+M)?(?:\d+W)?(?:\d+D)?T(?:\d+H)?(?:\d+M)?(?:\d+S)?/;
    const parts = value.match(regex);

    if (!parts) {
      return 'Invalid duration';
    }

    // Extract hours, minutes, and seconds
    const hours = value.match(/(\d+)H/);
    const minutes = value.match(/(\d+)M/);
    const seconds = value.match(/(\d+)S/);

    // Convert numerical values to German text
    const hoursText = hours ? `${hours[1]} Stunde(n) ` : '';
    const minutesText = minutes ? `${minutes[1]} Minute(n) ` : '';
    const secondsText = seconds ? `${seconds[1]} Sekunde(n)` : '';

    return `${hoursText}${minutesText}${secondsText}`.trim();
  }

}
